export const minCompetitors = 2;
export const maxCompetitors = 10;

export const minCriteria = 2;
export const maxCriteria = 10;

export const minRoles = 2;
export const maxRoles = 10;